import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './UserSearch.css';

function UserSearch({ tableData }) {
    return (
        <div className="user_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para la busqueda</h4>
            )}
        </div>
    );
}

export default UserSearch;
